module.exports = __webpack_public_path__ + "static/get-app-bg-9a38b5414d0c1da41329faa539881baf.png";